module.exports = __webpack_public_path__ + "assets/img/contact.6c09542a.png";